import React, {useState} from "react";
import Graph from "./components/graph";
import {Box} from "@material-ui/core";
import useClasses from "scenes/graph/index.style";
import {getUnixTime, fromUnixTime, startOfToday} from "date-fns";
import ErrorLoading from "cis-common-ts/dist/components/error-loading";
import {useGraphData, useCurrentData} from "state/queries";
import {DateTimePicker} from "@material-ui/pickers";
import {graphDataTypes} from "entities/graph-data-types";
import AutocompleteOptions from "cis-common-ts/dist/components/autocomplete-options";
import {StationData} from "entities/station-data";

const GraphScene: React.FC = () => {
    const classes = useClasses();


    const [ fromTime, setFromTime ] = useState(getUnixTime(startOfToday()));
    const [ toTime, setToTime ] = useState(getUnixTime(new Date()));
    const [ selectedDataType, setSelectedDataType ] = useState(graphDataTypes[0]);
    const [ selectedStation, setSelectedStation ] = useState<StationData>();

    const setFromTo = (fromTime: number, toTime: number) => {
        setFromTime(Math.min(fromTime, toTime));
        setToTime(Math.max(fromTime, toTime));
    }

    const {
        data: stations,
        isLoading: stationsLoading,
        isError: stationsError,
        refetch: refetchStations
    } = useCurrentData({
        onSuccess: (stations) => {
            setSelectedStation(stations[0])
        }
    });

    const {
        data: graphData,
        isLoading,
        isError,
        refetch,
    } = useGraphData(
        selectedStation?.stationId ?? -1,
        selectedDataType,
        fromTime,
        toTime,
        !!stations
    );

    return (
        <Box className={classes.root}>
            <ErrorLoading
                isLoading={isLoading || stationsLoading}
                isError={isError || stationsError}
                errorMessage={"Nepodařilo se stáhnout data z meteostanic"}
                reload={() => {
                    stationsError && refetchStations();
                    isError && refetch();
                }}
            >
                <Box className={classes.container}>
                    <Box className={classes.optionsBox}>
                        <AutocompleteOptions
                            className={classes.stationSelect}
                            label="Stanice"
                            options={stations || []}
                            value={selectedStation}
                            onChange={setSelectedStation}
                            getOptionLabel={station => station.stationName}
                        />
                        <AutocompleteOptions
                            className={classes.dataTypeSelect}
                            label="Veličina"
                            options={graphDataTypes}
                            value={selectedDataType}
                            onChange={setSelectedDataType}
                            getOptionLabel={graphDataType => graphDataType.label}
                        />
                        <DateTimePicker
                            label={"Od"}
                            value={fromUnixTime(fromTime)}
                            onChange={(date) => date && setFromTo(getUnixTime(date), toTime)}
                            format="d.M. yyyy - HH:mm"
                            maxDate={fromUnixTime(toTime)}
                            ampm={false}
                            minutesStep={60}
                        />
                        <DateTimePicker
                            label={"Do"}
                            value={fromUnixTime(toTime)}
                            onChange={(date) => date && setFromTo(fromTime, getUnixTime(date))}
                            format="d.M. yyyy - HH:mm"
                            disableFuture
                            ampm={false}
                            minutesStep={60}
                        />
                    </Box>
                    { graphData && (
                        <Graph
                            title="Teplota"
                            unit={selectedDataType.unit}
                            data={ graphData.map(datum => (datum as any).value === "NaN"
                                ? { ...datum, value: null }
                                : datum
                            )}
                        />
                    )}
                </Box>
            </ErrorLoading>
        </Box>
    )
}

export default GraphScene;
